<template>
  <div class="row">
    <div class="col-md-12 pad-to-5">
      <pos-user-form :route="route" @on-submit="onUserSubmit"></pos-user-form>
    </div>
  </div>
</template>
<script>
  import PosUserForm from './PosUserForm.vue'
  export default {
    components: {
      PosUserForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        orderPosModel: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onUserSubmit (model, isValid) {
        this.orderPosModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/users/PosUserEdit.vue